"use client";

import { createGlobalStyle } from "styled-components";

/**
 * Global style for preventing body scrolling via the ScrollStore.
 */
export const ModalStyle = createGlobalStyle`
  /* Prevent scrolling behind react-modal */
  body.ReactModal__Body--open.noscroll {
    -webkit-overflow-scrolling: touch;
    overflow: hidden;
    width: 100%;
    padding-right: var(--scrollbar-width);
  }
`;
